<template>
  <ui-dropdown-menu>
    <ui-dropdown-menu-trigger as-child>
      <ui-button
        variant="ghost"
        class="w-full justify-between gap-2 px-3 font-normal text-muted-foreground"
        :aria-label="tr('Language')"
      >
        <span class="flex min-w-0 items-center gap-2">
          <languages-icon class="size-4 shrink-0" />
          <span class="truncate">{{ availableLanguages[language] }}</span>
        </span>
        <chevron-down-icon class="size-4 shrink-0" />
      </ui-button>
    </ui-dropdown-menu-trigger>
    <ui-dropdown-menu-content
      align="start"
      side="top"
      :side-offset="8"
      class="w-(--reka-dropdown-menu-trigger-width) min-w-44"
    >
      <ui-dropdown-menu-item
        v-for="(label, langcode) of availableLanguages"
        :key="'language-select-' + langcode"
        class="gap-2"
        @select="() => setLanguage(langcode)"
      >
        {{ label }}
        <check-icon v-if="langcode === language" class="ml-auto size-4" />
      </ui-dropdown-menu-item>
    </ui-dropdown-menu-content>
  </ui-dropdown-menu>
</template>

<script>
import { Check, ChevronDown, Languages } from '@lucide/vue';

/** Interface language picker (stored in the app store), as in Creator. */
export default {
  name: 'LanguageSelect',
  components: {
    CheckIcon: Check,
    ChevronDownIcon: ChevronDown,
    LanguagesIcon: Languages,
  },
  computed: {
    language() {
      return this.$store.getters['app/language'];
    },
    availableLanguages() {
      return this.$store.getters['app/availableLanguages'];
    },
  },
  methods: {
    setLanguage(langcode) {
      this.$store.commit('app/language', langcode);
    },
  },
};
</script>
